import { ENVIRONMENT_BASE } from "./default";

export const environment = {
  production: true,
  ...ENVIRONMENT_BASE,
};
